import React from "react";

const SpecialCard = ({ img, title, price, desc }) => {
  return (
    <div class="bg-lemonyellow flex flex-col w-64 md:h-[420px] h-[300px] rounded-xl md:mx-4 md:my-0 my-4 relative shadow-xl drop-shadow-md">
      <div class="rounded-xl md:h-40 h-28 mb-0 md:mb-2">
        <img
          src={img}
          alt={title}
          class="rounded-t-xl w-full h-full object-cover"
        />
      </div>
      <div class="p-4">
        <div class="flex flex-row justify-between mb-1 md:mb-4">
          <h1 class="font-karla font-bold">{title}</h1>
          <h2 class="font-karla text-[#E80000] font-bold">${price}</h2>
        </div>
        <p class="text-[10pt] font-karla mb-2">{desc}</p>
      </div>
      <div class="absolute bottom-3 md:bottom-5 left-4 flex flex-row justify-between">
        <h1 class="font-karla font-bold mr-14">Order for delivery</h1>
        <img src="dishicon.svg" alt="Dish Icon" class="w-5" />
      </div>
    </div>
  );
};

export default SpecialCard;
